import moment from 'moment'

export class EntityCollection {

	static filter (collection, {type, modifiedSince, offset=0, limit=1000, fields=""} = {}) {
		const ts0 = Date.now();

		if (modifiedSince) {
			// We need to pass this argument to milliseconds precision
			modifiedSince = moment(modifiedSince).valueOf();
		}

		if (fields) {
			fields = fields
				.split(";")
				.map(i =>
					i.split(",")
					.map(q => {
						let args = q.split(/(:|¬|[<>]=?|=|!)/);

						let field = args[0];
						let oper = args[1];
						let value = args[2];

						if (oper == ":" || oper == "¬") {
							// FIXME Will fail if e.g., "%80\% chocolate%"
							value = new RegExp(value.replace(/%/g, ".*"), "i");
						}

						return {field, value, oper};
					})
				)
		}

		let entities = [];
		const sieve = (value, key, iterNum) => {

			if (type) {
				if (!(value.type == type)) {
					return;
				}
			}

			if (modifiedSince) {
				if (moment(value.updatedOn).valueOf() <= modifiedSince) {
					return;
				}
			}

			if (offset) {
				if (iterNum < offset) {
					return;
				}
			}

			if (limit) {
				if (iterNum > limit) {
					return;
				}
			}

			if (fields) {
				const match = fields.map( andOp => {
					return andOp.map( orOp => {
						const property = value[orOp.field] || value.data[orOp.field];
						switch (orOp.oper) {
							case "=":
								return property == orOp.value;
							case ":":
								return orOp.value.test(property);
							case "¬":
								return !orOp.value.test(property);
							case "<":
								return property < orOp.value;
							case ">":
								return property > orOp.value;
							case "<=":
								return property <= orOp.value;
							case ">=":
								return property >= orOp.value;
							case "!":
								return !property;
							default:
								return false;
						}
					}).some(op => !!op)
				}).every(op => !!op)

				if (!match) {
					return;
				}
			}

			entities.push(value);
		};

		let count = 0;
		for (let entity of collection) {
			sieve(entity, entity.id, count++);
		}

		const ts1 = Date.now();
		return entities;
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/JMan/EntityCollection.js